import Vue from 'vue'
import './plugins/vuels.js'
import moment from 'moment'

import store from './store'
import '../theme/index.css'
import ElementUI from 'element-ui';
import VueCookies from "vue-cookies";
import echarts from 'echarts'
import './assets/icon/iconfont.css'

import App from './App'
import router from './router'
import './styles/reset.css'


Vue.use(VueCookies);
Vue.use(ElementUI);
Vue.prototype.$moment = moment
Vue.prototype.$echarts = echarts

//todo 解决路由跳转报错
import Router from 'vue-router'

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}
Vue.config.productionTip = false;

let sensors = require('sa-sdk-javascript');
sensors.init({
  server_url: 'http://log-dev.cailiangyun.com/log/track',
  // show_log: true,//打印
  is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
  use_client_time: true,
  send_type: 'beacon',
  heatmap: {
    //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
    clickmap: 'default',
    // clickmap: 'not_collect',
    //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
    scroll_notice_map: 'default'
  }
});
// 注册公共属性
sensors.registerPage({
  platform_type: 'Web',
  $app_name: "cailiangtong",
  $app_version: "0.4.0",
});
sensors.quick('autoTrack'); //用于采集 $pageview 事件。

Vue.prototype.$sensors = sensors;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js